import { NullableClassName } from '@squareup/dex-types-shared-ui';
import React from 'react';

const MoonIcon = ({ className = '' }: NullableClassName) => (
  <svg
    className={className}
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-test-icon-moon
  >
    <path
      d="M9.745 8.67A5.414 5.414 0 0 1 5.006.636c.132-.238-.065-.54-.326-.463a6.549 6.549 0 1 0 8.146 8.148c.078-.26-.224-.457-.462-.326a5.39 5.39 0 0 1-2.619.675z"
      fill="#7BBFFF"
    />
  </svg>
);

export { MoonIcon };
